import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'newCheckout/types/Theme'

const wrapperStyles = ({ theme }: Theme) => css`
  label: wrapper;

  display: flex;

  margin-bottom: ${theme.spacings.giga};
  padding: ${theme.spacings.kilo} ${theme.spacings.mega};

  background-color: ${theme.colors.n100};

  border-radius: ${theme.borderRadius.giga};
`

export const Wrapper = styled('div')(wrapperStyles)
